import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styled from 'styled-components';

const StyledTitle = styled.h5`
  font-weight: bold;
  color: #007bff;
`;

const StyledBody = styled.p`
  color: gray;
  white-space: pre-wrap; /* Preserve whitespace and line breaks */
`;

const AlertDialog = ({ show, title, bodyMessage, buttonName, buttonFunction, onHide, error = false }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <StyledTitle 
          className={error ? 'text-danger' : ''}
        >{title}</StyledTitle>
      </Modal.Header>
      <Modal.Body>
        <StyledBody>{bodyMessage}</StyledBody>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={buttonFunction}>
          {buttonName}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AlertDialog;